export const ApplicationNames = {
  HUB: 'Hub',
  LENS: 'Lens',
  THERAPIES_SITES: 'Therapies Sites',
  THERAPIES_SPONSORS: 'Therapies Sponsors',
};
